'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { useWeb3Context } from '@/contexts/Web3Context';
import { useBorrowPositionsTableData } from '@/hooks/positions/useBorrowPositionsTableData';
const EMPTY: ReadonlySet<string> = new Set();

/**
 * Markets the connected wallet borrows on, as lowercased `chainId-marketId` keys, or `undefined`
 * while the answer is unknown so callers gating a funds-moving action fail closed.
 */
export const useBorrowPositionMarketIds = t0 => {
  const $ = _c(4);
  const enabled = t0 === undefined ? true : t0;
  const {
    account
  } = useWeb3Context();
  const t1 = enabled && account.isConnected ? account.address : undefined;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      accountAddress: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    borrowPositions,
    countTotal,
    partial,
    isPending,
    isPaused,
    error,
    isPlaceholderData
  } = useBorrowPositionsTableData(t2);
  let t3;
  bb0: {
    if (isPending || isPaused || error || isPlaceholderData) {
      t3 = undefined;
      break bb0;
    }
    if (partial || countTotal > borrowPositions.length) {
      t3 = undefined;
      break bb0;
    }
    if (borrowPositions.length === 0) {
      t3 = EMPTY;
      break bb0;
    }
    let t4;
    if ($[2] !== borrowPositions) {
      t4 = new Set(borrowPositions.map(_temp));
      $[2] = borrowPositions;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    t3 = t4;
  }
  return t3;
};
function _temp(t0) {
  const {
    market
  } = t0;
  return `${market.chainId}-${market.marketId}`.toLowerCase();
}